export const TRIAL_PLANS = {
  STANDARD_ATTENDANCE_TRIAL: -2001,
  ADVANCED_ATTENDANCE_TRIAL: -2021,
  ESSENTIALS_ATTENDANCE_TRIAL: -3000,
  PRO_ATTENDANCE_TRIAL: -3001,
  PREMIUM_ATTENDANCE_TRIAL: -3002,
  PREMIUM_ATTENDANCE_FREE_TRIAL_2024: -3102,
  PRO_ATTENDANCE_FREE_TRIAL_2024: -3101,
  ESSENTIALS_ATTENDANCE_FREE_TRIAL_2024: -3100,
  PREMIUM_ATTENDANCE_FREE_TRIAL_2024_V2: -3202,
  PRO_ATTENDANCE_FREE_TRIAL_2024_V2: -3201,
  ESSENTIALS_ATTENDANCE_FREE_TRIAL_2024_V2: -3200,
  TRIAL_PLAN_2025: -4001,
  TRIAL_PLAN_2025_V2: -4101,
  TRIAL_PLAN_2025_V3: -4201,
};

export const STRIPE_PLANS = {
  STRIPE_ADVANCED: 2015,
  STRIPE_ADVANCED_ATTENDANCE: 2025,
  STRIPE_STANDARD: 2035,
  STRIPE_STANDARD_ATTENDANCE: 2005,
  ESSENTIALS_STRIPE: 3005,
  ESSENTIALS_ATTENDANCE_STRIPE: 3015,
  PRO_STRIPE: 3025,
  PRO_ATTENDANCE_STRIPE: 3035,
  PREMIUM_STRIPE: 3045,
  PREMIUM_ATTENDANCE_STRIPE: 3055,
  ESSENTIALS_STRIPE_2024: 3105,
  ESSENTIALS_ATTENDANCE_STRIPE_2024: 3115,
  PRO_STRIPE_2024: 3125,
  PRO_ATTENDANCE_STRIPE_2024: 3135,
  PREMIUM_STRIPE_2024: 3145,
  PREMIUM_ATTENDANCE_STRIPE_2024: 3155,
  ESSENTIALS_STRIPE_2024_V2: 3205,
  ESSENTIALS_ATTENDANCE_STRIPE_2024_V2: 3215,
  PRO_STRIPE_2024_V2: 3225,
  PRO_ATTENDANCE_STRIPE_2024_V2: 3235,
  PREMIUM_STRIPE_2024_V2: 3245,
  PREMIUM_ATTENDANCE_STRIPE_2024_V2: 3255,
  SINGLE_LOCATION_OLD_BILLING_ENGINE: 4000,
  SINGLE_LOCATION_NEW_BILLING_ENGINE: 4005,
  MULTI_LOCATION_OLD_BILLING_ENGINE: 4010,
  MULTI_LOCATION_NEW_BILLING_ENGINE: 4015,
  ADVANCED_OLD_BILLING_ENGINE: 4020,
  ADVANCED_NEW_BILLING_ENGINE: 4025,
  FREE_PLAN: 3160,
  SINGLE_LOCATION_OLD_BILLING_ENGINE_V2: 4100,
  SINGLE_LOCATION_NEW_BILLING_ENGINE_V2: 4105,
  MULTI_LOCATION_OLD_BILLING_ENGINE_V2: 4110,
  MULTI_LOCATION_NEW_BILLING_ENGINE_V2: 4115,
  ADVANCED_OLD_BILLING_ENGINE_V2: 4120,
  ADVANCED_NEW_BILLING_ENGINE_V2: 4125,
  SINGLE_LOCATION_OLD_BILLING_ENGINE_V3: 4200,
  SINGLE_LOCATION_NEW_BILLING_ENGINE_V3: 4205,
  MULTI_LOCATION_OLD_BILLING_ENGINE_V3: 4210,
  MULTI_LOCATION_NEW_BILLING_ENGINE_V3: 4215,
  ADVANCED_OLD_BILLING_ENGINE_V3: 4220,
  ADVANCED_NEW_BILLING_ENGINE_V3: 4225,
};

export const TRIAL_SUBSCRIPTIONS = {
  TRIAL_SUB_SMALL_BIZ: 1004,
  TRIAL_SUB_ENTERPRISE: 1005,
};

export const PRICING_GROUPS = {
  SMALL_BUSINESS: { id: 'pricing-2021', label: 'Small Business' },
  ENTERPRISE: { id: 'pricing-ent-2021', label: 'Enterprise' },
  ENTERPRISE_LITE: { id: 'pricing-entl-2021', label: 'Enterprise Lite' },
  PRICING_2022: { id: 'pricing-2022', label: 'Pricing 2022' },
  PRICING_2023: { id: 'pricing-2023', label: 'Pricing 2023' },
  PRICING_2024: { id: 'pricing-2024', label: 'Pricing 2024' },
  PRICING_2024_V2: { id: 'pricing-2024-v2', label: 'Pricing 2024 v2' },
  CUSTOM_ONLY: { id: 'pricing-none', label: 'Custom ONLY' },
};
